import { Meal } from "@/clients/models/Meal";
import { MealTime } from "@/clients/models/MealTime";
import { InfoIcon } from "@/components/icons/info-icon";
import { TextButton } from "@/components/ui/buttons";
import { cn } from "@/utils/cn";
import { useMealDetailData } from "../../hooks/use-meal-detail-data";

interface PlanDetailButtonProps {
  meal: Meal;
  mealTime: MealTime;
  mealIndex?: number;
  mealDay?: string;
  targetDate?: string;
  onBeforeOpenDetail?: () => void;
  classNames?: {
    button?: string;
    icon?: string;
  };
  saveSearchParams?: boolean;
}

/**
 * Button to view meal details
 * Opens the meal detail page with comprehensive information
 */
export const PlanDetailButton = ({
  meal,
  mealTime,
  mealDay,
  targetDate,
  mealIndex,
  onBeforeOpenDetail,
  classNames,
  saveSearchParams = true,
}: PlanDetailButtonProps) => {
  const { onMealDetailClick } = useMealDetailData();
  return (
    <TextButton
      className={cn("w-fit", classNames?.button)}
      onClick={() => {
        onBeforeOpenDetail?.();
        onMealDetailClick(
          {
            meal,
            mealTime,
            mealIndex,
            mealDay,
            targetDate,
          },
          saveSearchParams,
        );
      }}
      aria-label="View meal details"
    >
      <InfoIcon className={cn(classNames?.icon)} />
    </TextButton>
  );
};
